import { useAsyncModule } from 'async-modules';
import type { Modules } from 'types';
import makeHocFromHook, { HookedProps } from './makeHocFromHook';

const propName = 'streamModule' as const;

const withStreamModule = makeHocFromHook({
    hook: useAsyncModule,
    input: 'stream',
    propName,
});

export namespace WithStreamModuleTypes {
    export type WithStreamModule = HookedProps<
        (moduleName: 'stream') => StreamModule | null,
        typeof propName
    >;
    export type StreamModule = Modules['stream']['default'];
}

export default withStreamModule;
